import graphql__721aa4692d2312495c16 from "./__generated__/PageSectionSidebarPagesList_pageSection.graphql.js";import { graphql, useFragment } from "react-relay";

import { useSidebarSectionTitle } from "./useSidebarSectionTitle";
import ButtonLink from "../Buttons/ButtonLink";

const PageSectionSidebarPagesList = props => {
  const pageSection = useFragment(
    PageSectionSidebarPagesList_pageSection,
    props.pageSection
  );

  const { resourceTargets } = pageSection;
  const { title } = useSidebarSectionTitle({ pageSection });

  return (
    <div className="page-section page-section-sidebar-pages-list card box page-section-sidebar-box border-radius-bottom">
      {title}

      <ul className="card-body list-unstyled margin-bottom-none">
        {resourceTargets.map(resourceTarget => (
          <li key={resourceTarget.id} className="card-list-item">
            <ButtonLink
              href={resourceTarget.url}
              className="btn btn-primary-inverse btn-block-md"
              label={resourceTarget.name}
              iconClassName="icon-arrow-right"
              iconPosition="after"
              innerClassName="text-default"
            />
          </li>
        ))}
      </ul>
    </div>
  );
};

const PageSectionSidebarPagesList_pageSection = graphql__721aa4692d2312495c16;

export default PageSectionSidebarPagesList;
